module.exports = __webpack_public_path__ + "img/logo-main.02d7f2b1.png";